import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Slider from 'react-slick'
interface Image {
    link: string;
    alt: string;
}

interface Props {
    text: string;
    imageList: Image[];
}

const ValueBarSection = (props: Props) => {

    const slickMobileSettings = {
        dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: false
    }

    return (
        <div className="value-bar">
            <div className="value-bar-desktop">
                <div className="value-bar__content-wrapper">
                    <div className="value-bar__content-wrapper__logo-wrapper">
                        <div className="value-bar__content-wrapper__logo-wrapper__logo-chunk">
                            {
                                props.imageList.map(imageProp=> {
                                    return (
                                        <div className="value-bar__value">
                                            <img className="value-bar__image" src={imageProp.link}/>
                                            <div className="value-bar__text">{imageProp.alt}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <span className="value-bar__content-wrapper__logo-overlay-wrapper"/>
                </div>
            </div>
            <div className="value-bar-mobile">
                <Slider {...slickMobileSettings}>
                    {
                        props.imageList.map(imageProp=> {
                            return (
                                <div className="value-bar__value">
                                    <img className="value-bar__image" src={imageProp.link}/>
                                    <div className="value-bar__text">{imageProp.alt}</div>
                                </div>
                            )
                        })
                    }
                </Slider>
            </div>
        </div>
    );
};

export default function render() {
    const elements = document.getElementsByClassName('value-bar-section');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const imageJSON = element.getAttribute('data-imageList');
        const imageList = JSON.parse(imageJSON || '');
        return ReactDOM.render(
            <ValueBarSection
                text={element.getAttribute('data-text') || ''}
                imageList={imageList}
            />,
            element,
        );
    });
}
